var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M5.49984 5.83333V15C5.49984 15.9205 6.24603 16.6667 7.1665 16.6667H13.8332C14.7537 16.6667 15.4998 15.9205 15.4998 15V5.83333M5.49984 5.83333H4.6665M5.49984 5.83333H7.1665M15.4998 5.83333H16.3332M15.4998 5.83333H13.8332M7.1665 5.83333V4.16667C7.1665 3.24619 7.9127 2.5 8.83317 2.5H12.1665C13.087 2.5 13.8332 3.24619 13.8332 4.16667V5.83333M7.1665 5.83333H13.8332",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M8.83301 9.16797V13.3346M12.1663 9.16797V13.3346",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteSvg);
export default __webpack_public_path__ + "static/media/deleteSvg.33840a7de0f13907e5251152e72a1995.svg";
export { ForwardRef as ReactComponent };